import React from 'react'
import { connect } from 'react-redux'
import {Redirect, withRouter} from 'react-router-dom'
import MfaCodeForm from '../forms/MfaCodeForm'
import MfaForm from '../forms/MfaForm'
import { getCustomer, logout, resetVerifiedUser, setMfaValidated, clearRedirectTo } from '../redux/actions'
import AuthLayout from "./AuthLayout";
import store from "../store";
import AjaxLoader from "../components/AjaxLoader";
import DataSource from "../DataSource";

class Mfa extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            showUsernameCopy: false,
            showCodeForm: false,
            hasError: false,
            mfaAction: '',
            redirect: false,
            isLoading: false,
            mobileNumber: '',
            email: ''
        }

        this.timer = null
    }

    componentDidMount () {
        this.handleGetMaskedData()
	    this.redirectIfLoggedIn()
    }

    checkUserDetailsExist () {
        if (!this.props.customerId && this.props.isLoggedIn) {
            this.props.getCustomer()
        }
    }

    componentWillUnmount () {
	    if (this.timer) {
            clearTimeout(this.timer)
        }
    }

    redirectIfLoggedIn () {
        if (!this.props.isLoggedIn) {
            this.props.history.push('/login')
        }
    }

    handleGetMaskedData () {
        const onSuccess = (response) => {
            if (response) {
                this.setState({mobileNumber: response.data.mobile && response.data.mobile, email: response.data.email && response.data.email})
            }
        }
        const onFailure = (error) => {
            if (error) {
                this.setState({hasError: true})
            }
        }

        DataSource.getCustomerMaskedEmailAndMobile(onSuccess, onFailure)
    }

    handleGetCodeSuccess(response, values) {
        this.setState({isLoading: false})
        if (response.status === 200) {
            this.setState({ showCodeForm: true, mfaAction: values.action })
        } else {
            this.setState({ showCodeForm: false, hasError: true })
        }
    }

    handleSubmitCodeSuccess(response) {
        if (response.data && response.data.valid) {
            this.checkUserDetailsExist()
            this.props.setMfaValidated()
            this.redirect()
        } else {
            this.setState({hasError: true})
        }
    }

    handleError(response) {
        this.setState({isLoading: false})
        if (response.response.status === 401) {
            // The users session is invalid and needs to re-login
            this.props.logout()
        }
    }

    handleResendCode() {
        this.setState({isLoading: true})
        DataSource.postSendMfaCode(this.state.mfaAction, this.handleGetCodeSuccess.bind(this), this.handleError.bind(this))
    }

    redirect () {
        const redirectTo = store.getState().auth.redirectTo

        this.setState({
            redirectTo: redirectTo || '/'
        }, () => {
            this.setState({ redirect: true })
        })
    }

    render () {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirectTo} />;
        }

        // Present SMS/Email choice form first. Then input code box form once code has been sent.
        return (
            <AuthLayout
                title='Verify your account'
                subTitle=''
                className='login-page mfa-page'
                backLinkLocation='logout'
            >
                {this.state.showCodeForm === false ?
                    <MfaForm
                        mobileNumber={this.state.mobileNumber}
                        emailAddress={this.state.email}
                        setSuccessMsg={response => response.data.label}
                        handleSuccess={this.handleGetCodeSuccess.bind(this)}
                        handleFailure={this.handleError.bind(this)}
                    />
                    : !this.state.isLoading ?
                        <MfaCodeForm
                            fields={{action: this.state.mfaAction}}
                            handleFailure={this.handleError.bind(this)}
                            handleSuccess={this.handleSubmitCodeSuccess.bind(this)}
                            handleResendCode={this.handleResendCode.bind(this)}
                        />
                        : ''
                }
                {this.state.isLoading ? <AjaxLoader /> : ''}
                {this.state.hasError && <div className="row-error">Sorry we're unable to process this request, please try again or contact customer support at 13 39 38</div>}
            </AuthLayout>
        )
    }
}


const mapStateToProps = state => ({
    redirectTo: state.auth.redirectTo,
    isLoggedIn: state.auth.isLoggedIn,
    mobileNumber: state.auth.contactMobile,
    customerId: state.auth.id,
    email: state.auth.contactEmail,
    brand: state.auth.brand,
    mfaEnabled: state.auth.mfaEnabled
})

export default connect(mapStateToProps, { getCustomer, logout, resetVerifiedUser, setMfaValidated, clearRedirectTo })(withRouter(Mfa))



// WEBPACK FOOTER //
// ./resources/js/auth/Mfa.js